"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capability = exports.Context = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useCapabilities_1 = require("../../hooks/useCapabilities");
exports.Context = react_1.createContext(null);
const Capability = (_a) => {
    var { has, some, someOrEmpty, all, children, fallback } = _a, options = __rest(_a, ["has", "some", "someOrEmpty", "all", "children", "fallback"]);
    const hooked = useCapabilities_1.useCapabilities(options);
    react_1.useEffect(() => {
        if (Number(!!has) + Number(!!some) + Number(!!all) + Number(!!someOrEmpty) !== 1) {
            if (process.env.NODE_ENV !== 'production') {
                throw new Error('Exactly one of has, some, someOrEmpty and all props must be passed to the capability component.');
            }
        }
    }, [has, some, all, someOrEmpty]);
    if (has && hooked.has(has)) {
        return jsx_runtime_1.jsx(exports.Context.Provider, Object.assign({ value: has }, { children: children }), void 0);
    }
    if (some && hooked.some(some)) {
        return jsx_runtime_1.jsx(exports.Context.Provider, Object.assign({ value: `${some.join('/')}` }, { children: children }), void 0);
    }
    if (someOrEmpty && hooked.someOrEmpty(someOrEmpty)) {
        return (jsx_runtime_1.jsx(exports.Context.Provider, Object.assign({ value: someOrEmpty.length > 0
                ? someOrEmpty.length === 1
                    ? someOrEmpty[0]
                    : `${someOrEmpty.join(' or ')}`
                : null }, { children: children }), void 0));
    }
    if (all && hooked.all(all)) {
        return jsx_runtime_1.jsx(exports.Context.Provider, Object.assign({ value: `${all.join('+')}` }, { children: children }), void 0);
    }
    return fallback ? jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: fallback }, void 0) : null;
};
exports.Capability = Capability;
exports.default = exports.Capability;
//# sourceMappingURL=index.js.map